import React from "react";
import {Box, Breadcrumbs, Link, Paper, Typography} from "@mui/material";
import useApiCall from "../../hooks/CancellableApiCall";
import {LoadingContent} from "../../components/LoadingContent";
import {Link as RouterLink, useParams} from "react-router-dom";
import {DetailedResourceResponse} from "../../data/DetailedResourceResponse";
import {EditorContent} from "../../components/editor/EditorContent";
import {Division} from "../../data/Division";

interface ViewResourcePageContentProps {
    resource: DetailedResourceResponse;
    divisionIdentifier: string;
    divisionDisplayName: string;
}

function ViewResourcePageContent({resource, divisionIdentifier, divisionDisplayName}: ViewResourcePageContentProps) {
    const divisionUrl = divisionIdentifier.replaceAll("_", "-");

    return (
        <Box>
            <Breadcrumbs sx={{mb: 2, fontSize: "0.85rem"}}>
                <Link component={RouterLink} to="/" underline="hover" color="text.secondary">
                    Home
                </Link>
                <Link component={RouterLink} to="/resources" underline="hover" color="text.secondary">
                    Resources
                </Link>
                <Link component={RouterLink} to={`/resources/${divisionUrl}`} underline="hover" color="text.secondary">
                    {divisionDisplayName}
                </Link>
                <Typography color="text.primary" fontSize="0.85rem">
                    {resource.title}
                </Typography>
            </Breadcrumbs>

            <Paper variant="outlined" sx={{mt: 2, p: 2}}>
                <EditorContent content={resource.content}/>
            </Paper>
        </Box>
    );
}

export const ViewResourcePage = () => {
    const params = useParams();
    const divisionIdentifier = params.divisionIdentifier?.replaceAll("-", "_") ?? "";

    const resource = useApiCall<DetailedResourceResponse>({
        url: `/api/resource/entry/${divisionIdentifier}/${params.resourceIdentifier}`
    });

    const divisions = useApiCall<Division[]>({
        url: `/api/division/list-divisions`,
    });

    const divisionDisplayName = divisions.data?.find(d => d.identifier === divisionIdentifier)?.displayName
        ?? divisionIdentifier.replaceAll("_", " ");

    return (
        <LoadingContent isLoading={resource.isLoading || !resource}>
            <ViewResourcePageContent
                resource={resource.data!!}
                divisionIdentifier={divisionIdentifier}
                divisionDisplayName={divisionDisplayName}
            />
        </LoadingContent>
    );
};
